import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import AdminLayout from '@/components/AdminLayout';
import axios from 'axios';
import { Package, FolderTree, TrendingUp, Tag } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const AdminDashboard = () => {
  const [stats, setStats] = useState({
    products_count: 0,
    categories_count: 0,
    active_offers: 0
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchStats();
  }, []);

  const fetchStats = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(`${API_URL}/api/stats`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setStats(response.data);
    } catch (error) {
      console.error('Error fetching stats:', error);
    } finally {
      setLoading(false);
    }
  };

  const cards = [
    {
      title: 'Total Produse',
      value: stats.products_count,
      icon: Package,
      color: 'text-blue-400',
      bgColor: 'bg-blue-400/10',
      href: '/admin/products'
    },
    {
      title: 'Categorii',
      value: stats.categories_count,
      icon: FolderTree,
      color: 'text-green-400',
      bgColor: 'bg-green-400/10',
      href: '/admin/categories'
    },
    {
      title: 'Oferte Active',
      value: stats.active_offers,
      icon: Tag,
      color: 'text-red-400',
      bgColor: 'bg-red-400/10',
      href: '/admin/products'
    }
  ];

  return (
    <AdminLayout title="Dashboard">
      <div data-testid="admin-dashboard">
        {/* Stats Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-10">
          {cards.map((card, index) => (
            <Link
              key={index}
              to={card.href}
              className="admin-card p-6 hover:border-[#D4AF37]/30 transition-all"
              data-testid={`stat-${card.title.toLowerCase().replace(' ', '-')}`}
            >
              <div className="flex items-start justify-between">
                <div>
                  <p className="text-[#A3A3A3] text-sm mb-2">{card.title}</p>
                  <p className="text-white text-3xl font-bold">
                    {loading ? '...' : card.value}
                  </p>
                </div>
                <div className={`w-12 h-12 ${card.bgColor} flex items-center justify-center`}>
                  <card.icon className={card.color} size={24} />
                </div>
              </div>
            </Link>
          ))}
        </div>

        {/* Quick Actions */}
        <div className="mb-10">
          <h2 className="text-white font-serif text-xl mb-4">Acțiuni Rapide</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
            <Link
              to="/admin/products"
              className="admin-card p-6 text-center hover:border-[#D4AF37]/30 transition-all"
            >
              <Package className="text-[#D4AF37] mx-auto mb-3" size={32} />
              <p className="text-white font-medium">Adaugă Produs</p>
            </Link>
            <Link
              to="/admin/categories"
              className="admin-card p-6 text-center hover:border-[#D4AF37]/30 transition-all"
            >
              <FolderTree className="text-[#D4AF37] mx-auto mb-3" size={32} />
              <p className="text-white font-medium">Gestionează Categorii</p>
            </Link>
            <Link
              to="/admin/pages"
              className="admin-card p-6 text-center hover:border-[#D4AF37]/30 transition-all"
            >
              <TrendingUp className="text-[#D4AF37] mx-auto mb-3" size={32} />
              <p className="text-white font-medium">Editează Pagini</p>
            </Link>
            <a
              href="/"
              target="_blank"
              rel="noopener noreferrer"
              className="admin-card p-6 text-center hover:border-[#D4AF37]/30 transition-all"
            >
              <Tag className="text-[#D4AF37] mx-auto mb-3" size={32} />
              <p className="text-white font-medium">Vezi Site</p>
            </a>
          </div>
        </div>

        {/* Info */}
        <div className="admin-card p-6">
          <h2 className="text-white font-serif text-xl mb-4">Informații Utile</h2>
          <div className="text-[#A3A3A3] text-sm space-y-2">
            <p>• Pentru a adăuga un produs nou, mergi la <strong>Produse</strong> și apasă "Adaugă Produs"</p>
            <p>• Poți adăuga multiple imagini pentru fiecare produs</p>
            <p>• Produsele cu badge "ofertă" vor apărea evidențiate pe site</p>
            <p>• Pentru a face un produs disponibil în configuratorul 3D, bifează opțiunea corespunzătoare</p>
          </div>
        </div>
      </div>
    </AdminLayout>
  );
};

export default AdminDashboard;
